import { RuleDecl } from "vue/types/options";
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import Brands from "./Brands";

export const validations: RuleDecl = {
    brandName: {
        brandRequired: required,
        minBrandLength: minLength(4),
        maxBrandLength: maxLength(300),
        unique: (value: string, component: Brands) => {
            if (!!component) {
                return (component.brands?.findIndex(u => u.name.localeCompare(value) === 0) < 0 ?? true);
            } else {
                return true;
            }
        },
    },
    editingBrandName: {
        brandRequired: required,
        minBrandLength: minLength(4),
        maxBrandLength: maxLength(300),
        unique: (value: string, component: Brands) => {
            if (!!component) {
                return (component.brands?.findIndex(u => u.name.localeCompare(value) === 0 &&
                    u.brandId !== component.editingBrandId) < 0 ?? true);
            } else {
                return true;
            }
        },
    },
};

export const validationMessages = {
    brandRequired: "Brand is required",
    minBrandLength: "Brand must have at least {min} letters",
    maxBrandLength: "Brand must have less than {max} letters",
    unique: "Brand must be unique",
};
